import { LegalShell } from '@/pages/legal/LegalShell';

export default function Terminos() {
  return (
    <LegalShell title="Términos y condiciones" updated="2026" testId="terms-page">
      <p>Estos términos describen el funcionamiento actual de Bodegón Mi Barrio (Bodegon53.com) en su versión operativa manual. Al usar la plataforma aceptas las condiciones siguientes.</p>
      <h2>1. Naturaleza del servicio</h2>
      <p>Bodegón Mi Barrio es un mercado en línea multi-tienda que conecta a compradores con vendedores minoristas y mayoristas. Cada oferta pertenece a una tienda concreta y solo puede comprarse cuando esa tienda tiene precio, cobertura de entrega y existencias físicas reales para tu ubicación.</p>
      <h2>2. Precios y disponibilidad</h2>
      <ul>
        <li>Todos los precios, existencias, gastos de envío y descuentos se calculan y autorizan en el servidor al momento de comprar; los valores mostrados durante la navegación son de referencia.</li>
        <li>Si la oferta de la tienda elegida deja de estar disponible, te pediremos confirmar cualquier alternativa antes de continuar; nunca cambiamos de tienda de forma silenciosa.</li>
      </ul>
      <h2>3. Pagos</h2>
      <ul>
        <li>Los pagos se realizan por medios externos acordados con el vendedor. La plataforma <strong>no cobra automáticamente</strong> ni ejecuta transferencias.</li>
        <li>El registro manual de un pago es un asiento de evidencia, no un cobro ni una transferencia bancaria automática.</li>
      </ul>
      <h2>4. Barrio Puntos</h2>
      <ul>
        <li>Ganas 1 punto por cada USD 1 de subtotal de productos (el envío no genera puntos), únicamente después de que el pedido se entrega y el pago externo queda registrado.</li>
        <li>1 punto equivale a USD 0.01 de descuento; puedes redimir hasta el 50 % del subtotal de productos. Ante reembolsos, los puntos ganados o redimidos se ajustan de forma proporcional.</li>
      </ul>
      <h2>5. Productos regulados</h2>
      <p>La eventual presencia de medicamentos u otros productos regulados requiere revisión y autorización regulatoria por parte de los responsables antes de ofrecerse a la venta.</p>
      <h2>6. Cuentas y acceso</h2>
      <p>Los nuevos registros de propietarios y mayoristas requieren identificación y aprobación de un administrador de plataforma. El acceso de las cuentas existentes se conserva.</p>
      <h2>7. Funciones pendientes</h2>
      <p>Franquicias, cobros automáticos, facturación de suscripciones y notificaciones por correo/SMS todavía no están activos y no deben interpretarse como servicios en funcionamiento.</p>
      <h2>8. Contacto</h2>
      <p>Puedes escribirnos desde la página de <a className="underline" href="/contacto">Contacto</a>. Los canales externos oficiales se publicarán cuando estén configurados.</p>
    </LegalShell>
  );
}
